import React, { useState, useEffect } from "react";
import HedonicSpider from "../charts/HedonicSpider";
import HedonicScatter from "../charts/HedonicScatter";
// import FakeSpiderData from '../../pages/FakeSpiderData';
// import FakeScatterData from '../../pages/FakeScatterData';
import CampaignCard from "../campainCard/CampaignCard";
import TopBox from "../topBox/TopBox";
import Spinner from "../common/spinner/Spinner";
import "./Hedonic.css";

const Hedonic = ({ hedonic, metadata }) => {
  const [cards, setCards] = useState(hedonic.Result);
  const [cardSelected, setCardSelected] = useState(hedonic.Result[0]);

  const [hedonicData, setHedonicData] = useState({
    isLoading: true,
    spiderChart: [],
    scatterChart: [hedonic.Scatter_plot],
    topBox: [],
  });

  const handleSelected = (card) => {
    setCardSelected(card);
  };

  // useEffect(() => {
  //   var spiderChartDatas = hedonic.Spider_charts;
  //   var TopBoxDatas = hedonic.Top_box;

  //   var spiderChartProduct = spiderChartDatas
  //     .filter((item) => {
  //       return item.Product == cardSelected.Product;
  //     })
  //     .map((item) => item.Spider_chart);

  //   var topBoxProduct = TopBoxDatas.filter((item) => {
  //     return item.Product == cardSelected.Product;
  //   }).map((item) => item.Top_box_table);

  //   var cloneHedonicData = {
  //     ...hedonicData,
  //     isLoading: false,
  //     spiderChart: spiderChartProduct,
  //     topBox: topBoxProduct,
  //   };

  //   setHedonicData(cloneHedonicData);
  // }, [cardSelected]);

  useEffect(() => {
    var spiderChartDatas = hedonic.Spider_charts;
    var TopBoxDatas = hedonic.Top_box;

    var spiderChartProduct = spiderChartDatas
      .filter((item) => {
        return item.Product == cardSelected.Product;
      })
      .map((item) => item.Spider_chart);

    var topBoxProduct = TopBoxDatas.filter((item) => {
      return item.Product == cardSelected.Product;
    }).map((item) => item.Top_box_table);

    var cloneHedonicData = {
      ...hedonicData,
      isLoading: false,
      spiderChart: spiderChartProduct,
      topBox: topBoxProduct,
    };

    setHedonicData(cloneHedonicData);
  }, [cardSelected]);

  return (
    <>
      {hedonicData.isLoading == true ? (
        <Spinner size="medium" color="grey" position="center" />
      ) : (
        <div className="container">
          <div className="container__cards">
            {cards.map((card) => (
              <CampaignCard
                card={card}
                key={card.PRODUCT}
                onSelected={(card) => handleSelected(card)}
                cardSelected={cardSelected}
              />
            ))}
          </div>
          <div className="boxes">
            <HedonicSpider
              data={hedonicData.spiderChart[0]}
              metadata={metadata}
              cardSelected={cardSelected}
            />
            <HedonicScatter
              data={hedonicData.scatterChart}
              metadata={metadata}
              cardSelected={cardSelected}
            />
          </div>
          <TopBox
            data={hedonicData.topBox}
            cometadatampany={metadata}
            cardSelected={cardSelected}
          />
        </div>
      )}
    </>
  );
};

export default Hedonic;
